import { getRequest, postRequest, putRequest } from "../services/apiHelpers";

export const getBooks = async (params) => {
  try {
    const res = await getRequest({ url: "books", query: params });
    return res;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const postBook = async (payload) => {
  try {
    const res = await postRequest({ url: "books", payload: payload });
    return res;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const putBook = async ({ id, payload }) => {
  try {
    const res = await putRequest({
      url: "books",
      payload: payload,
      query: { BOOK_ID: id },
    });
    return res;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getFeaturedBooks = async (params) => {
  try {
    const res = await getRequest({ url: "books/featured", query: params });
    return res;
  } catch (error) {
    throw new Error(error.message);
  }
};
